import { render, staticRenderFns } from "./NoProposal.vue?vue&type=template&id=19802130&scoped=true"
import script from "./NoProposal.vue?vue&type=script&lang=js"
export * from "./NoProposal.vue?vue&type=script&lang=js"
import style0 from "./NoProposal.vue?vue&type=style&index=0&id=19802130&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19802130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19802130')) {
      api.createRecord('19802130', component.options)
    } else {
      api.reload('19802130', component.options)
    }
    module.hot.accept("./NoProposal.vue?vue&type=template&id=19802130&scoped=true", function () {
      api.rerender('19802130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/NoProposal.vue"
export default component.exports